import React, { memo } from 'react';
export const TimelineSection = memo(function TimelineSection() {
  const timeline = [{
    time: 'Día 1',
    result: 'Entendés cómo funciona la electricidad en tu casa y trabajás con protocolo de seguridad real'
  }, {
    time: 'Semana 1',
    result: 'Resolvés reparaciones domiciliarias básicas: tomacorrientes, llaves, empalmes y luminarias'
  }, {
    time: 'Semana 2',
    result: 'Dominás tu tablero: sabés leer térmicas, probar el diferencial y diagnosticar fallas'
  }, {
    time: 'Semana 3',
    result: 'Sos capaz de planificar y presupuestar una instalación completa desde cero'
  }, {
    time: 'Semana 4',
    result: 'Aplicás normativa AEA, realizás mediciones certificadas y gestionás tu primer cliente profesional'
  }, {
    time: '30 Días',
    result: 'Tenés el conocimiento completo para trabajar, cobrar y crecer como electricista profesional en Argentina',
    highlight: true
  }];
  return null;
});